
<div class="split-view">
    <div class="split-view__body">
        <slot />
    </div>
</div>
